<template lang="pug">
div(class="d-flex flex-column flex-grow-1 min-h-0 tw-h-full fill-height overflow-hidden")
  div(class=" tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pb-1 tw-text-left")
    v-row
      v-col
        span(class=" tw-text-2xl text-secondary tw-font-bold tw-capitalize ") {{ $t('Opportunities.Common.createOpportunity') }}

  div(class=" tw-flex tw-h-full tw-flex-row tw-flex-grow tw-p-4 tw-pb-0 tw-pl-2 tw-overflow-hidden")
    v-form(ref="form" v-model="valid" lazy-validation @keyup.native.enter="valid && submit($event)" class="tw-w-full")
      v-row(align="start" justify="center" class="tw-pt-2 tw-pb-10")
        v-col(cols="11")
          v-row
            v-col
              v-text-field(v-model="opportunity.name" :label="$t('Common.name')" class="tw-capitalize" outlined hide-details)

          v-row
            v-col
              v-menu(
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="auto"
                :nudge-right="20"
                :nudge-top="-5"
              )
                template(v-slot:activator="{ on, attrs }")
                  v-text-field(
                    v-model="opportunity.expected_close_date"
                    :label="$t('Opportunities.Common.decisionBy')"
                    outlined
                    hide-details
                    v-on="on"
                    v-bind="attrs"
                    class="tw-capitalize"
                  )
                v-date-picker(
                  v-model="opportunity.expected_close_date"
                  flat
                  no-title
                  dark
                  locale="en"
                  elevation="0"
                  class=" tw-border-none tw-rounded-sm"
                ) 
            v-col
              v-text-field(
                v-model="opportunity.amount"
                :label="$t('Opportunities.Common.commissionValue')"
                outlined
                hide-details
                class="tw-capitalize"
              )
          v-row
            v-col
              v-textarea(
                v-model="opportunity.description"
                outlined
                hide-details
                :label="$t('Common.description')"
                class="tw-capitalize"
              )

  div(class="tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pt-1 ")
    v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
      v-col(cols="auto" align-end class="tw-h-full fill-height")
        v-btn(@click="cancel" text :ripple="false")
          span(class=" tw-text-kPurple tw-mt-4") {{ $t('Common.cancel') }}
        v-btn(depressed color="rgba(94,129,244,0.80)" :loading="loading" @click="submit")
          span(class="tw-font-bold") {{ $t('Common.save') }}
</template>
<script>
export default {
  props: {
    relate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      opportunity: {},
      loading: false,
      valid: true,
    };
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.opportunity.stage = 1;
        if (this.relate) {
          this.opportunity.lead_id = this.$store.getters['leads/current_lead'].id;
        }
        this.$store
          .dispatch('opportunities/add', this.opportunity)
          .then((response) => {
            if (this.relate) {
              this.$store.dispatch('leads/view', this.$store.getters['leads/current_lead'].id);
              this.$store.dispatch('leads/list');
            }
            this.$emit('close');
            this.loading = false;
          })
          .catch((error) => {
            commit('SET_ERROR', error, { root: true });
          });
      }
    },
  },
};
</script>
